<template>
  <div class="pricing-cards-subsection">
    <div class="pricing-grid">
      <!-- Basique Plan -->
      <div class="pricing-card">
        <div class="card-content">
          <div class="card-header">
            <h3 class="plan-name">Basique</h3>
            <div class="price-wrapper">
              <span class="price">59€/mois</span>
            </div>
            <p class="plan-description">
              Idéal pour démarrer avec un outil moderne sans complexité.
            </p>
            <p class="plan-description">
              Notre offre propose un ensemble de fonctionnalites de base à prix abordable,
              idéal pour démarrer rapidement. 
            </p>
          </div>
          <ul class="features-list">
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Caisse certifiée intuitive</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Export comptable</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Rapports de base</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Devis et Facturation optimisée</span>
            </li>
          </ul>
          <router-link class="cta-button secondary" to="/inscription">
            <span class="button-text">Commencer l'essai</span>
          </router-link>
        </div>
      </div>

      <!-- Croissance Plan (Popular) -->
      <div class="pricing-card popular">
        <div class="popular-badge">Le plus populaire</div>
        <div class="card-content">
          <div class="card-header">
            <h3 class="plan-name">Croissance</h3>
            <div class="price-wrapper">
              <span class="price">89€/mois</span>
            </div>
            <p class="plan-description">
              L'outil tout-en-un pour structurer et développer son activité.
            </p>
            <p class="plan-description" >
              Avec cette offre accédée à des fonctionnalités avancées et un support client client dédié pour optimiser votre expérience.
            </p>
          </div>
          <ul class="features-list">
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Toutes les fonctionnalités du pack Basique</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Gestion avancée des commandes</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Facturation et devis personnalisables</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Fidélisation clients</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Marketing Social</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Accompagnement et privilégié **</span>
            </li>
          </ul>
          <router-link class="cta-button primary" to="/inscription">
            <span class="button-text">Choisir ce plan</span>
          </router-link>
        </div>
      </div>

      <!-- Premium Plan -->
      <div class="pricing-card">
        <div class="card-content">
          <div class="card-header">
            <h3 class="plan-name">Premium</h3>
            <div class="price-wrapper">
              <span class="price-custom">Sur mesure</span>
            </div>
            <p class="plan-description">
              Une solution complète pour piloter et anticiper.
            </p>
             <p class="plan-description">
              Notre offre combine un ensemble complet de fonctionnalités, un support prioritaire et une intégration avancée.
            </p>
          </div>
          <ul class="features-list">
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Toutes les fonctionnalités du Pack Pro</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Site e-commerce sur mesure</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Synchronisation e-commerce avancée</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Toutes spécificités</span>
            </li>
            <li class="feature-item">
              <img class="check-icon" alt="Check" src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg" />
              <span>Un accompagnement & support export ***</span>
            </li>
           
          </ul>
          <router-link class="cta-button secondary" to="/contact">
            <span class="button-text">Nous contacter</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PricingCardsSubsection",
});
</script>

<style>
.pricing-cards-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafb;
  display: flex;
  flex-direction: column;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.pricing-cards-subsection .pricing-grid {
  align-items: flex-start;
  display: grid;
  gap: 31px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-items: stretch;
  max-width: 1200px;
  min-width: 0;
  width: 100%;
}

.pricing-cards-subsection .pricing-card {
  background-color: #ffffff;
  border: 1px solid #dee1e6;
  border-radius: 10px;
  box-shadow: 0px 0px 2px rgba(23, 26, 31, 0.12);
  display: flex;
  min-width: 0;
  padding: 30px;
  position: relative;
  width: 100%;
}

.pricing-cards-subsection .pricing-card.popular {
  background: linear-gradient(to bottom, #e5ffd0 0%, #9fd675 100%);
  border: none;
  box-shadow: 0px 6px 14px rgba(106, 154, 115, 0.5);
}

.pricing-cards-subsection .popular-badge {
  background-color: #084734;
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-radius: 999px;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.12);
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 12px;
  font-weight: 600;
  left: 50%;
  letter-spacing: 0;
  line-height: 18px;
  padding: 6px 14px;
  position: absolute;
  text-align: center;
  top: -16px;
  transform: translateX(-50%);
  white-space: nowrap;
  width: auto;
}

.pricing-cards-subsection .card-content {
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
}

.pricing-cards-subsection .pricing-card.popular .card-content {
  gap: 38px;
}

.pricing-cards-subsection .card-header {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.pricing-cards-subsection .plan-name {
  color: #171a1f;
  font-family: "Montserrat", Helvetica;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 32px;
  margin: 0;
}

.pricing-cards-subsection .pricing-card.popular .plan-name {
  color: #084532;
}

.pricing-cards-subsection .price-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.pricing-cards-subsection .price {
  color: #084734;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 40px;
}

.pricing-cards-subsection .pricing-card.popular .price {
  color: #084532;
}

.pricing-cards-subsection .price-custom {
  color: #084734;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 40px;
}

.pricing-cards-subsection .plan-description {
  color: #565d6d;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0;
}

.pricing-cards-subsection .pricing-card.popular .plan-description {
  color: #000000;
}

.pricing-cards-subsection .features-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pricing-cards-subsection .pricing-card.popular .features-list {
  gap: 12px;
}

.pricing-cards-subsection .feature-item {
  align-items: center;
  display: flex;
  gap: 10px;
}

.pricing-cards-subsection .pricing-card.popular .feature-item {
  gap: 12px;
}

.pricing-cards-subsection .check-icon {
  flex-shrink: 0;
  height: 20px;
  width: 20px;
}

.pricing-cards-subsection .feature-item span {
  color: #171a1f;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
}

.pricing-cards-subsection .pricing-card.popular .feature-item span {
  color: #000000;
}

.pricing-cards-subsection .cta-button {
  all: unset;
  align-items: center;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: 48px;
  overflow: hidden;
  padding: 10px 16px;
  position: relative;
  text-align: center;
  transition: all 0.2s ease;
  width: 100%;
}

.pricing-cards-subsection .cta-button.primary {
  background-color: #084734;
}

.pricing-cards-subsection .cta-button.secondary {
  background-color: #f1ffe6;
}

.pricing-cards-subsection .pricing-card:not(.popular) .cta-button.secondary {
  border: 1px solid #084734;
}

.pricing-cards-subsection .cta-button.primary .button-text {
  color: #ffffff;
}

.pricing-cards-subsection .cta-button.secondary .button-text {
  color: #354540;
}

.pricing-cards-subsection .button-text {
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  position: static;
  white-space: normal;
  word-break: break-word;
}

@media (max-width: 1100px) {
  .pricing-cards-subsection .pricing-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 20px;
  }

  .pricing-cards-subsection .pricing-card {
    width: 100% !important;
  }
}

@media (max-width: 768px) {
  .pricing-cards-subsection {
    padding: 64px 16px;
  }

  .pricing-cards-subsection .pricing-grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 16px;
  }

  .pricing-cards-subsection .pricing-card {
    padding: 20px 16px;
  }

  .pricing-cards-subsection .popular-badge {
    font-size: 11px;
    line-height: 16px;
    padding: 5px 12px;
    top: -14px;
  }

  .pricing-cards-subsection .plan-name {
    font-size: 22px;
    line-height: 1.25;
  }

  .pricing-cards-subsection .price,
  .pricing-cards-subsection .price-custom {
    font-size: 32px;
    line-height: 1.2;
  }

  .pricing-cards-subsection .plan-description,
  .pricing-cards-subsection .feature-item span {
    font-size: 15px;
    line-height: 1.45;
  }
}
</style>
